var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "poetstool - table view",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 128",
    transform: "translate(7 4)",
    d: "M0 0h17v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 129",
    transform: "translate(7 11)",
    d: "M0 0h17v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 130",
    transform: "translate(7 18)",
    d: "M0 0h17v2H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 17)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.7e8bc547101bc668d585d89d2d710bd1.svg";
export { ForwardRef as ReactComponent };